import { FORM_LOGIN_FIELDS } from '../../consts/text/form-login';
import { Yup } from '../../utils';

export const formSchema = Yup.object().shape({
    [FORM_LOGIN_FIELDS.FIELD_EMAIL]: Yup.string().email().required(),
});
